__turbopack_context__.v({
  "ask": "SiteHeader-module__oJa3Ma__ask",
  "atTop": "SiteHeader-module__oJa3Ma__atTop",
  "audio": "SiteHeader-module__oJa3Ma__audio",
  "burger": "SiteHeader-module__oJa3Ma__burger",
  "burgerBar": "SiteHeader-module__oJa3Ma__burgerBar",
  "controls": "SiteHeader-module__oJa3Ma__controls",
  "header": "SiteHeader-module__oJa3Ma__header",
  "identity": "SiteHeader-module__oJa3Ma__identity",
  "inner": "SiteHeader-module__oJa3Ma__inner",
  "kbd": "SiteHeader-module__oJa3Ma__kbd",
  "langSwitch": "SiteHeader-module__oJa3Ma__langSwitch",
  "menu": "SiteHeader-module__oJa3Ma__menu",
  "menu-in": "SiteHeader-module__oJa3Ma__menu-in",
  "menuAudio": "SiteHeader-module__oJa3Ma__menuAudio",
  "menuClose": "SiteHeader-module__oJa3Ma__menuClose",
  "menuFoot": "SiteHeader-module__oJa3Ma__menuFoot",
  "menuGroupLabel": "SiteHeader-module__oJa3Ma__menuGroupLabel",
  "menuLink": "SiteHeader-module__oJa3Ma__menuLink",
  "menuLinkActive": "SiteHeader-module__oJa3Ma__menuLinkActive",
  "menuList": "SiteHeader-module__oJa3Ma__menuList",
  "menuMark": "SiteHeader-module__oJa3Ma__menuMark",
  "menuNav": "SiteHeader-module__oJa3Ma__menuNav",
  "menuNode": "SiteHeader-module__oJa3Ma__menuNode",
  "menuTop": "SiteHeader-module__oJa3Ma__menuTop",
  "menuTopActions": "SiteHeader-module__oJa3Ma__menuTopActions",
  "nav": "SiteHeader-module__oJa3Ma__nav",
  "navLink": "SiteHeader-module__oJa3Ma__navLink",
  "navLinkActive": "SiteHeader-module__oJa3Ma__navLinkActive",
  "navList": "SiteHeader-module__oJa3Ma__navList",
  "node": "SiteHeader-module__oJa3Ma__node",
  "nodeDot": "SiteHeader-module__oJa3Ma__nodeDot",
  "nodeText": "SiteHeader-module__oJa3Ma__nodeText",
  "pulse-node": "SiteHeader-module__oJa3Ma__pulse-node",
  "wordmark": "SiteHeader-module__oJa3Ma__wordmark",
});
